import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteConfirmDialog from '../dialog/DeleteConfirmDialog';
import theme from '../../theme';

const AdminDeleteButton = ({ onDelete, variant = 'default' }) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const buttonSize = variant === 'small' ? { xs: 32, lg: 24 } : { xs: 32, md: 40 };
  const iconSize = variant === 'small' ? { xs: 20, lg: 16 } : { xs: 16, md: 24 };

  const handleDeleteClick = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await onDelete();
      setIsDeleteDialogOpen(false);
    } catch (error) {
      console.error('Failed to delete:', error);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteDialogOpen(false);
  };

  return (
    <>
      <IconButton
        disableRipple
        onClick={handleDeleteClick}
        sx={{
          width: buttonSize,
          height: buttonSize,
          border: variant === 'small' ? 'none' : `1px solid ${theme.palette.grey.line}`,
          borderRadius: 1,
        }}
      >
        <CloseIcon
          sx={{
            width: iconSize,
            height: iconSize,
            color: theme.palette.black[3],
          }}
        />
      </IconButton>
      <DeleteConfirmDialog
        open={isDeleteDialogOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
      />
    </>
  );
};

export default AdminDeleteButton;
